var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d21ccd0a16bd99cf4a4b73db9c1f2c5e.svg#w';
                    var viewUrl = 'sprites.d21ccd0a16bd99cf4a4b73db9c1f2c5e.svg#view-w';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };